module.exports = __webpack_public_path__ + "resources/img/ic-nz.c6b6971d.png";